"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("../hooks");

var _components = require("../components");

var _nav = require("./footer/nav");

var _copyright = require("./footer/copyright");

var _footerModule = _interopRequireDefault(require("./footer.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Footer = function Footer() {
  var _useTheme = (0, _hooks.useTheme)(),
      theme = _useTheme.theme;

  var wrapperClassName = (0, _react.useMemo)(function () {
    return [_footerModule.default.wrapper, _footerModule.default[theme]].join(" ");
  }, [theme]);
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: wrapperClassName
  }, /*#__PURE__*/_react.default.createElement(_components.Container, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _footerModule.default.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _footerModule.default.nav
  }, /*#__PURE__*/_react.default.createElement(_nav.Nav, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: _footerModule.default.copy
  }, /*#__PURE__*/_react.default.createElement(_copyright.Copyright, null)))));
};

exports.Footer = Footer;